import {
  CONTRACT_STATUS,
  PAYMENT_STATUS,
} from '../../lib/config';

export const DOCUMENT_STATUS = {
  APPROVED: 5,
};

const statusId = status => status && status.id;

export const isContractFinalized = enrollment =>
  statusId(enrollment && enrollment.contract_status) === CONTRACT_STATUS.DONE;

export const isPaymentFinalizedOrExempt = (enrollment, proofSent = false) =>
  [
    PAYMENT_STATUS.PAYMENT_CONFIRMED,
    PAYMENT_STATUS.EXEMPT,
  ].includes(statusId(enrollment && enrollment.payment_status)) || proofSent;

export const isDocumentApproved = enrollment =>
  statusId(enrollment && enrollment.document_status) === DOCUMENT_STATUS.APPROVED;

export const canFinalizeEnrollment = (enrollment, proofSent = false) =>
  isContractFinalized(enrollment) &&
  isPaymentFinalizedOrExempt(enrollment, proofSent) &&
  isDocumentApproved(enrollment);
